module.exports = __webpack_public_path__ + "img/Popular_Logo_2020_White.9c1213e0.png";